import { render, staticRenderFns } from "./inputType.vue?vue&type=template&id=4020c992&scoped=true"
import script from "./inputType.vue?vue&type=script&lang=js"
export * from "./inputType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4020c992",
  null
  
)

export default component.exports